import {Container, Graphics, Rectangle} from "pixi.js";
import AlignUtil from "../utils/AlignUtil.ts";
import ICreate from "../interfaces/ICreate.ts";
import IDestroy from "../interfaces/IDestroy.ts";
import RhColors from "../models/RhColors.ts";

export default class GraphicsButton extends Container implements ICreate, IDestroy
{
    public btnHeight:number;
    public btnWidth:number;
    public cornerRadius:number;
    public fillAlpha:number;
    public fillAlphaHover:number;
    public fillColor:string;
    public fillColorDisabled:string;
    public fillColorHover:string;
    public fillColorPressed:string;
    public strokeAlign:number;
    public strokeAlpha:number;
    public strokeAlphaHover:number;
    public strokeColor:string;
    public strokeColorDisabled:string;
    public strokeColorHover:string;
    public strokeColorPressed:string;
    public strokeThickness:number;
    public usable:boolean;

    protected layer1:Container;
    
    private bgDefault:Graphics;
    private bgDisabled:Graphics;
    private bgHover:Graphics;
    private bgPressed:Graphics;

    constructor() {
        super();
        // init
        this.cornerRadius = 6;
        this.fillAlpha = 1;
        this.fillAlphaHover = 1;
        this.fillColor = RhColors.WHITE;
        this.fillColorHover = RhColors.BTN_PRIMARY;
        this.btnHeight = 35;
        this.btnWidth = 100;
        this.strokeAlign = AlignUtil.INNER;
        this.strokeAlpha = 1;
        this.strokeAlphaHover = 1;
        this.strokeColor = RhColors.BTN_PRIMARY;
        this.strokeColorHover = RhColors.WHITE;
        this.strokeThickness = 2;
        this.usable = true;
    }

    private assignListeners():void
    {
        this.onpointerout = (event) =>
        {
            this.pointerOut();
        }
        this.onpointerover = (event) =>
        {
            this.pointerOver();
        };
    }

    private createBackground():void
    {
        this.bgDefault = new Graphics();
        this.bgDefault.roundRect(0, 0, this.btnWidth, this.btnHeight, this.cornerRadius);
        this.bgDefault.fill({color:this.fillColor, alpha:this.fillAlpha});
        this.bgDefault.stroke({width:this.strokeThickness, color:this.strokeColor, alpha:this.strokeAlpha, alignment:this.strokeAlign});
        this.layer1.addChild(this.bgDefault);
    }

    private createBackgroundHover():void
    {
        this.bgHover = new Graphics();
        this.bgHover.roundRect(0, 0, this.btnWidth, this.btnHeight, this.cornerRadius);
        this.bgHover.fill({color:this.fillColorHover, alpha:this.fillAlphaHover});
        this.bgHover.stroke({width:this.strokeThickness, color:this.strokeColorHover, alpha:this.strokeAlphaHover, alignment:this.strokeAlign});
        this.bgHover.visible = false;
        this.layer1.addChild(this.bgHover);
    }
    
    private createLayer1():void
    {
        this.layer1 = new Container();
        this.addChild(this.layer1);
    }

    private destroyBackground():void
    {
        if(this.bgDefault)
        {
            this.removeChild(this.bgDefault);
            this.bgDefault.destroy();
            this.bgDefault = null;
        }
    }
    
    private destroyLayer1():void
    {
        if(this.layer1)
        {
            this.removeChild(this.layer1);
            this.layer1.destroy();
            this.layer1 = null;
        }
    }


    public create():void
    {
        this.createLayer1();
        this.createBackground();
        this.createBackgroundHover();
        this.cursor = "pointer";
        this.eventMode = "static";
        this.hitArea = new Rectangle(0, 0, this.btnWidth, this.btnHeight);
        this.assignListeners();
    }

    public override destroy():void
    {
        this.destroyBackground();
        this.destroyLayer1();
        super.destroy();
    }

    public disable():void
    {
        this.eventMode = null;
        this.cursor = null;
        if(this.bgDisabled)
        {
            if(this.bgHover)
            {
                this.bgHover.visible = false;
            }
            this.bgDefault.visible = false;
            this.bgDisabled.visible = true;
        }
        else
        {
            if(this.bgHover)
            {
                this.bgHover.visible = false;
            }
            this.bgDefault.visible = true;
            this.bgDefault.alpha = .5;
        }
    }

    public enable():void
    {
        if(!this.usable)
        {
            return;
        }
        if(this.bgDisabled)
        {
            this.bgDisabled.visible = false;
        }
        if(this.bgHover)
        {
            this.bgHover.visible = false;
        }
        this.bgDefault.alpha = 1;
        this.bgDefault.visible = true;
        this.cursor = "pointer";
        this.eventMode = "static";
    }

    protected pointerOut():void
    {
        this.bgHover.visible = false;
    }

    protected pointerOver():void
    {
        this.bgHover.visible = true;
    }
}
